export function hasFilter(selected) {
  return Object.values(selected).some(v => v != null)
}
